import React from 'react';
import { Row } from 'reactstrap';
import QcardPanel from '../../../_Components/QcardPanel/QcardPanel';
import { HintsContent } from '../../../_Components/QcardPanel/QcardHeader/QcardHints/Hint';
import EindexBadgeSection from './EindexBadgeSection';

// TODO: Change query

const EindexBadgeCard = props => {
  const { filters } = props;
  return (
    <QcardPanel {...props} hints={[HintsContent.HINT_EINDEX_BADGE]}>
      <Row className="containContent">
        <EindexBadgeSection filters={filters} />
      </Row>
    </QcardPanel>
  );
};

export default EindexBadgeCard;
